/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DevCodeIcon20Solid = forwardRef('DevCodeIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.202 3.343a1.25 1.25 0 0 0-2.404-.686l-4 14a1.25 1.25 0 0 0 2.404.686l4-14Z" }),
        React.createElement("path", { d: "M5.634 5.116a1.25 1.25 0 0 1 0 1.768L2.518 10l3.116 3.116a1.25 1.25 0 0 1-1.768 1.768L.75 11.768a2.5 2.5 0 0 1 0-3.536l3.116-3.116a1.25 1.25 0 0 1 1.768 0Z" }),
        React.createElement("path", { d: "M14.366 5.116a1.25 1.25 0 0 1 1.768 0l3.116 3.116a2.5 2.5 0 0 1 0 3.536l-3.116 3.116a1.25 1.25 0 0 1-1.768-1.768L17.482 10l-3.116-3.116a1.25 1.25 0 0 1 0-1.768Z" })));
});
